export type StatusKey = keyof typeof STATUS_CONFIG;
export interface ProgressStage {
    label: string;
    threshold: number;
}

export enum COLOR {
    Completed = "#22C55E",
    Progress = "#2563EB",
    ProgressInactive = "#58666C",
}

const STATUS_CONFIG = {
    draft: { label: "Draft", color: "#6B7280", bgColor: "#F3F4F6" },
    paid: { label: "Paid", color: "#FFFFFF", bgColor: "#3B82F6" },
    assigned: { label: "Assigned", color: "#FFFFFF", bgColor: "#8B5CF6" },
    inProgress: { label: "In Progress", color: "#FFFFFF", bgColor: "#F59E0B" },
    partiallyCompleted: { label: "Partially Completed", color: "#FFFFFF", bgColor: "#10B981" },
    completed: { label: "Completed", color: "#FFFFFF", bgColor: "#9AA7B8" },
    pendingReview: { label: "Pending Review", color: "#FFFFFF", bgColor: "#EF4444" },
    active: { label: "Active", color: "#FFFFFF", bgColor: "#22C55E" },
} as const;


const STATUS_ID_MAP: Record<number, StatusKey> = {
    1: "paid",
    2: "paid",
    3: "assigned",
    4: "inProgress",
    5: "partiallyCompleted",
    6: "completed",
    7: "pendingReview",
    10: "draft",
};


const PROGRESS_STAGES: ProgressStage[] = [
    { label: "Started", threshold: 0 },
    { label: "In progress", threshold: 50 },
    { label: "Completed", threshold: 100 },
];

export const getProgressByDocuments = (documents: any[]): number => {
    if (!documents || documents.length === 0) return 0;

    // Backend document_status_id truth (see app/Controllers/_Projects.php#811):
    //   1=New, 2=In Progress, 3=Ready for Review (legacy), 4=Completed, 5=In Revision (legacy)
    const allNew = documents.every((doc: any) => Number(doc.document_status_id) === 1);
    const allCompleted = documents.every((doc: any) => Number(doc.document_status_id) === 4);

    if (allCompleted) return 100;
    if (allNew) return 5;
    return 50;
};

export { STATUS_CONFIG, STATUS_ID_MAP, PROGRESS_STAGES };
